import React from "react";
import "./project.css";
import plagiarism from "../../assets/plag.avif";
import organ from "../../assets/organ.jpeg";
import task from "../../assets/tasks.jpg";
import summarization from "../../assets/abs.jpg";
import nlp from "../../assets/auto.webp";
import kubernetes from "../../assets/kub.png";
import skin from "../../assets/skin.avif";

const Works = () => {
  return (
    <section id="projects">
      <h2 className="worksTitle">My Projects</h2>
      <p className="worksDesc">
        A collection of my academic, research, and personal projects across
        <b> Web Development, AI/ML, Cloud, and Automation</b>.
      </p>

      <div className="category">
        <h3 className="catTitle">🌐 Web & Applications</h3>
        <div className="projectGrid">
          <div className="projectCard">
            <img src={plagiarism} alt="Plagiarism Report Manager" />
            <h4>Plagiarism Report Manager</h4>
            <p>
              Plagiarism Checking Web Application is a role-based portal for
              educational institutions that allows Faculty to upload documents,
              Librarians to manage reports, and Admins to oversee users.
            </p>
            <p>Tools Used: HTML, CSS, JavaScript, PHP, MySQL, PHPMailer</p>
            <a
              href="https://github.com/pragathi916/Plagiarism_Report_Manager"
              target="_blank"
              rel="noopener noreferrer"
              className="sourceBtn"
            >
              View Source Code
            </a>
          </div>

          <div className="projectCard">
            <img src={organ} alt="Organ Donation" />
            <h4>Organ Donation Portal</h4>
            <p>
              A web platform connecting donors with verified organizations,
              tracking contributions, and visualizing impact through
              real-time analytics
            </p>
            <p>Tools Used: HTML, CSS, JavaScript, PHP</p>
            <a
              href="https://github.com/pragathi916/OrganDonation_Website"
              target="_blank"
              rel="noopener noreferrer"
              className="sourceBtn"
            >
              View Source Code
            </a>
          </div>

          <div className="projectCard">
            <img src={task} alt="Task Manager" />
            <h4>Task Manager</h4>
            <p>Simple productivity app to track and manage daily tasks.</p>
            <a
              href="https://github.com/pragathi916/Task_Manager_App"
              target="_blank"
              rel="noopener noreferrer"
              className="sourceBtn"
            >
              View Source Code
            </a>
          </div>
        </div>
      </div>

      <div className="category">
        <h3 className="catTitle">🤖 AI / NLP</h3>
        <div className="projectGrid">
          <div className="projectCard">
            <img src={summarization} alt="Abstractive Summarization" />
            <h4>Abstractive Text Summarization</h4>
            <p>
              Created an Abstractive text summarization system for movie plots
              and NCERT textbooks, enhancing accessibility with quick, accurate
              summaries using NLP.
            </p>
            <a
              href="https://github.com/pragathi916/Abstractive_Summarization"
              target="_blank"
              rel="noopener noreferrer"
              className="sourceBtn"
            >
              View Source Code
            </a>
          </div>

          <div className="projectCard">
            <img src={nlp} alt="NLP Automation" />
            <h4>NLP Automation</h4>
            <p>
              Built an NLP-based tool to turn test steps written in plain English
              into machine-readable data for network testing. Extracted key
              details like device settings and traffic info automatically.
            </p>
            <p>Tools Used: Python, NLP (spaCy), Regex.</p>
            <a
              href="https://github.com/pragathi916/NOKIA_HACKATHON"
              target="_blank"
              rel="noopener noreferrer"
              className="sourceBtn"
            >
              View Source Code
            </a>
          </div>

          <div className="projectCard">
            <img src={skin} alt="Skin Cancer Detection" />
            <h4>Skin Cancer Detection</h4>
            <p>ML model to classify skin images for early cancer detection.</p>
            <a
              href="https://github.com/pragathi916/SKIN_CANCER_DETECTION"
              target="_blank"
              rel="noopener noreferrer"
              className="sourceBtn"
            >
              View Source Code
            </a>
          </div>
        </div>
      </div>

      <div className="category">
        <h3 className="catTitle">☁️ Cloud & DevOps</h3>
        <div className="projectGrid">
          <div className="projectCard">
            <img src={kubernetes} alt="Kubernetes Strategies" />
            <h4>Kubernetes Deployment Strategies</h4>
            <p>
              Implementing Blue-Green, Canary, and Rolling deployment strategies
              to enhance application availability.
            </p>
            <a
              href="https://github.com/pragathi916/Kubernete_Deployment_Strategies"
              target="_blank"
              rel="noopener noreferrer"
              className="sourceBtn"
            >
              View Source Code
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Works;
